import { spacing } from '@chegg-ui/theme'
import styled from 'styled-components'

export const ProofReaderEditorContainer = styled.div<{
  isRewritePanelActive?: boolean
}>`
  user-select: ${(props) => (props.isRewritePanelActive ? 'none' : null)};
  padding: 0 ${spacing.px24} 0 ${spacing.px40};
  flex: 1;
`
